import script from "./infoBlog.vue?vue&type=script&setup=true&lang=js"
export * from "./infoBlog.vue?vue&type=script&setup=true&lang=js"

import "./infoBlog.vue?vue&type=style&index=0&id=835cc47e&lang=scss&scoped=true"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-835cc47e"]])

export default __exports__